import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import _ from "lodash";
import { ParticipantsStatus } from "../../../../ReactConst";
import ClassNames from "classnames";
import moment from "moment";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import { useTranslation } from 'react-i18next';
export default function ModaleParticipants(props) {
  const { t } = useTranslation();
  const [styleFadeIn, setFadeIn] = useState(true);
  const closeParticipantModal = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.onCloseModaleParticipants();
    }, 400);
  }, []);

  return (
    <StyleRoot>
      <div
        class="modal fade modal-skin show actif"
        id="modalParticipants"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalParticipants"
        aria-hidden="true"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={closeParticipantModal}
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div class="modal-body">
                <section>
                  <h5 class="modal-title mt-0">
                    {!_.isEmpty(props.event.titre) &&
                      props.event.titre.charAt(0) +
                        props.event.titre.substring(1).toLowerCase()}
                    <span class="date-event-modal">
                      {!_.isEmpty(props.event.dateTime) &&
                        moment(props.event.dateTime).format("DD") +
                          " " +
                          moment(props.event.dateTime).format("MMMM") +
                          " " +
                          moment(props.event.dateTime).format("YYYY") +
                          " - " +
                          moment(props.event.dateTime).format("HH[h]mm")}
                    </span>
                  </h5>
                  {!_.isEmpty(props.event.participants) ? (
                    <ul class="list-participants">
                      {props.event.participants.map((item, index) => {
                        return item ? (
                          <li>
                            {!_.isEmpty(item.prenom) && !_.isEmpty(item.nom) ? (
                              <span class="name-participants">
                                {item.prenom.charAt(0).toUpperCase() +
                                  item.prenom.slice(1) +
                                  " " +
                                  item.nom.charAt(0).toUpperCase() +
                                  item.nom.slice(1)}
                              </span>
                            ) : (
                              <span class="name-participants">{t('communaute.deleted_account')}</span>
                            )}

                            <span
                              class={ClassNames("statut-participants", {
                                cancelled: item.statutInvitation === "DECLINEE",
                                confirmed: item.statutInvitation === "ACCEPTEE",
                                waiting: item.statutInvitation === "EN_ATTENTE",
                              })}
                            >
                              {ParticipantsStatus(
                                props.event.participants[index].statutInvitation, t
                              )}
                            </span>
                          </li>
                        ) : (
                          ""
                        );
                      })}
                    </ul>
                  ) : (
                    ""
                  )}
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
